<template>
    <v-dialog scrollable max-width="720" :fullscreen="isMobile" v-model="dialog" v-stack="{ open: dialog, close: hide }"
        @click:outside="hide">
        <v-card class="ex-modal">
            <div class="ex-hd">
                <button type="button" class="ex-close" @click="hide">
                    <v-icon size="14">mdi-close</v-icon>
                </button>
                <span class="ex-title">{{ titleLabel }}</span>
            </div>

            <div class="ex-body">
                <exercise-creator
                    ref="creator"
                    hide-title
                    hide-buttons
                    @success="onCreatorSuccess"
                    @loading="loading = $event"
                    @change:validation="isExerciseValid = $event"
                    :new-exercise="newEx"
                    :default-exercise="defaultExercise"
                    @cancel="hide"
                />
            </div>

            <div class="ex-foot">
                <v-btn depressed color="primary" class="ex-continue black--text" :disabled="!isExerciseValid"
                    @click="next" :loading="loading">
                    {{ continueLabel }}
                </v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import ExerciseCreator from "@/components/coach/routines/ExerciseCreator";

export default {
    name: "ExerciseCreatorDesktopDialog",
    components: {ExerciseCreator},
    props: {
        isSecondDialog: {
            type: Boolean,
            default: false,
        },
        defaultExercise: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            dialog: false,
            newEx: null,
            isExerciseValid: false,
            loading: false,
        }
    },
    computed: {
        titleLabel(vm = this) {
            return vm.defaultExercise ? vm.$t('exercises.edit_exercise') : vm.$t('exercises.create_exercise')
        },
        continueLabel(vm = this) {
            return vm.$t('common.save')
        }
    },
    methods: {
        next() {
            const vm = this
            if (!vm.$refs.creator) return
            vm.$refs.creator.next()
        },
        show(payload = null) {
            const vm = this
            if (payload) vm.newEx = payload
            vm.dialog = true
        },
        hide() {
            const vm = this
            vm.newEx = null
            vm.dialog = false
            vm.$emit('hide')
            vm.$nextTick(() => {
                if (vm.$refs.creator) vm.$refs.creator.reset()
            })
        },
        onCreatorSuccess(exercise) {
            const vm = this
            if (vm.$refs.creator) vm.$refs.creator.reset()
            vm.$emit('success', exercise)
            vm.hide()
        }
    },
}
</script>

<style scoped>
.ex-modal {
    background: var(--v-surface-base) !important;
    border: 1px solid var(--v-outline-base);
    border-radius: 14px !important;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    max-height: 90vh;
}

.ex-hd {
    height: 60px;
    background: var(--v-surface2-base);
    border-bottom: 1px solid var(--v-outline-base);
    display: flex;
    align-items: center;
    padding: 0 20px;
    gap: 12px;
    flex-shrink: 0;
}

.ex-close {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: var(--v-bg-base);
    border: 1px solid var(--v-outline2-base);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: var(--v-txtSecondary-base);
    transition: all .15s;
}

.ex-close:hover {
    background: var(--v-outline-base);
    color: var(--v-txtPrimary-base);
}

.ex-title {
    font-size: 16px;
    font-weight: 600;
    color: var(--v-txtPrimary-base);
}

.ex-body {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    padding: 24px;
}

.ex-foot {
    display: flex;
    border-top: 1px solid var(--v-outline-base);
    flex-shrink: 0;
}

.ex-continue {
    flex: 1;
    height: 52px !important;
    border-radius: 0 !important;
    font-weight: 700;
}

.v-dialog--fullscreen .ex-modal {
    max-height: 100vh;
    border: none;
    border-radius: 0 !important;
}

.v-dialog--fullscreen .ex-hd {
    height: calc(60px + var(--safe-area-inset-top, 0px));
    padding-top: var(--safe-area-inset-top, 0px);
}

.v-dialog--fullscreen .ex-continue {
    height: calc(52px + var(--safe-area-inset-bottom, 0px)) !important;
    padding-bottom: var(--safe-area-inset-bottom, 0px);
}
</style>